import { Component, ElementRef, ViewChild, Input } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
@Component({
    selector: 'select-chips',
    templateUrl: './SelectAndChips.html',
})
export class SelectAndChips {
    visible             : boolean  = true;
    selectable          : boolean  = true;
    removable           : boolean  = true;
    addOnBlur           : boolean  = false;
    separatorKeysCodes  : number[] = [ENTER, COMMA];
    itemCtrl            : FormControl = new FormControl();
    filtered_items      : Observable<string[]>;
    
    @Input()    selected_items      : any = [];
    @Input()    all_items           : any = [];
    @Input()    display             : string    = 'name';
    @Input()    display_chips       : string    = 'name';
    
    @ViewChild('statusInput', { static: false })    statusInput : ElementRef<HTMLInputElement>;
    @ViewChild('auto', { static: false })       matAutocomplete : MatAutocomplete;
    
    constructor() {
        this.filtered_items = this.itemCtrl.valueChanges.pipe(
            startWith(null),
            map((status: string | null) => status ? this._filter(status) : this.all_items.slice()));
    }
    
    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.selected_items.push({
                id: 0,
                name: value.trim()
            });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
        this.itemCtrl.setValue(null);
    }
    
    remove(status, indx): void {
        this.selected_items.splice(indx, 1);
    }
    
    selected(event: MatAutocompleteSelectedEvent): void {
        // console.log(event.option.value);
        this.selected_items.push(event.option.value);
        this.statusInput.nativeElement.value = '';
        this.itemCtrl.setValue(null);
    }
    
    private _filter(value: any): any[] {
        var probe = value === undefined || value === null ? "" : value;
        return this.all_items.filter(status => status[this.display].toLowerCase().includes(probe.toLowerCase()));
    }
}
